import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { NavigationService } from '../services/navigation/navigation.service';
import { IframeService } from '../services/iframe/iframe.service';

@Injectable({ providedIn: 'root' })
export class PreventInIframeGuard implements CanActivate {
  constructor(
    private iframeService: IframeService,
    private navigationService: NavigationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.iframeService.isInIframe()) {
      // not in iframe or iframe enabled -> return true
      return true;
    }

    // navigate to UserProfile page as default
    this.navigationService.navigateToUserProfile();
    return false;
  }
}
